import { $, $$ } from '@utils';
import Swiper from 'swiper';
import { Navigation, A11y, EffectFade, FreeMode, Controller } from 'swiper/modules';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';
import datalayerPushGeneric from '@utils/DataLayerPushGeneric';

function init() {
  if (!$('[data-au-product-header]')) return;

  addEventListeners();
  buildSlider();
}

function addEventListeners() {
  $$('[data-au-product-link]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const titleText = btn.closest('section').querySelector('[data-au-title]').innerText;

      datalayerPushGeneric(e, 'navigation', 'clickEnlace', titleText);
    });
  });
}

function buildSlider() {
  $$('[data-au-product-header-slider]').forEach((slider) => {
    const container = slider.closest('[data-au-product-header]');
    const paginationWrapper = container.querySelector('[data-au-product-header-pagination-slider-wrapper]');
    const pagination = container.querySelector('[data-au-product-header-pagination-slider]');
    const pagButton = container.querySelectorAll('[data-au-product-header-pag-button]');
    const slidesLength = pagButton.length;

    const mainSlider = new Swiper(slider, {
      modules: [A11y, EffectFade, Controller],
      navigation: {
        prevEl: slider.closest('[data-au-product-header-slider-wrapper]').querySelector('[data-au-slider-prev]'),
        nextEl: slider.closest('[data-au-product-header-slider-wrapper]').querySelector('[data-au-slider-next]'),
      },
      scrollbar: {
        el: slider.closest('[data-au-product-header-slider-wrapper]').querySelector('[data-au-slider-scrollbar]'),
      },
      freeMode: true,
      a11y: {
        enabled: true,
        slideRole: null,
      },
      direction: 'vertical',
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      slideToClickedSlide: true,
      pagination,
      on: {
        slideChange: setActive,
        slideNextTransitionStart: (e) => {
          dataLayerOnSlideNextTransition(e, true);
        },
        slidePrevTransitionStart: (e) => {
          dataLayerOnSlideNextTransition(e);
        },
      },
    });

    if (pagination) {
      const pagButton = paginationWrapper.querySelectorAll('[data-au-product-header-pag-button]');

      const paginationSlider = new Swiper(pagination, {
        modules: [Navigation, A11y, FreeMode, Controller],
        spaceBetween: 16,
        navigation: {
          prevEl: paginationWrapper.querySelector('[data-au-slider-prev]'),
          nextEl: paginationWrapper.querySelector('[data-au-slider-next]'),
        },
        scrollbar: {
          el: paginationWrapper.querySelector('[data-au-slider-scrollbar]'),
        },
        slidesPerView: 'auto',
        freeMode: true,
        a11y: {
          enabled: true,
          slideRole: null,
        },
        direction: 'vertical',
        slidesOffsetBefore: slidesLength > 5 && 48,
        slidesOffsetAfter: slidesLength > 5 && 48,
      });

      pagButton.forEach((button, i) => {
        button.addEventListener('click', () => {
          mainSlider.slideTo(i);
          paginationSlider.slideTo(i);
        });
      });

      mainSlider.controller.control = paginationSlider;
    }
  });
}

function setActive(e) {
  const pagBullets = e.el.closest('[data-au-product-header]').querySelectorAll('[data-au-product-header-pag-button]');

  pagBullets.forEach((sibling) => {
    sibling.classList.remove('au-product-header__bullet--active');
  });

  pagBullets[e.activeIndex].classList.add('au-product-header__bullet--active');
}

function dataLayerOnSlideNextTransition(e, next) {
  const nextOrPrev = next ? 'siguiente' : 'previa';
  const titleText = e.el.closest('section').querySelector('[data-au-title]').innerText;
  const item_id = `${removeAccentMarkAndUppercase(titleText)}_slide ${nextOrPrev}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickSlider',
    item_id,
  });
}

export default { init };
